import PropTypes from 'prop-types';

export const InfoMessage = ({ message, ...props }) => (
  <div className='flex items-center mv3'>
    <img className='w2 mr2' src={require('assets/img/info.png')} alt='info' />
    <div className='flx-i white' {...props}>{message}</div>
  </div>
);

InfoMessage.propTypes = {
  message: PropTypes.string.isRequired,
};
